module.exports = __webpack_public_path__ + "img/profile-active-v2.4516d6f7.svg";